import React from 'react';
import { challengeCalendarBreadcrumb } from '@constants/breadcrumbItems';
import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import Title from 'lib/src/components/typography/Title';
import Calendar from './Calendar';
import useFetchCalendarChallenges from './_hooks/useFetchCalendarChallenges';
import { isEmpty } from 'lib/src/utils/generic';
import CalendarFilters from './CalendarFilters';

function ChallengeCalendar() {
    const {
        calendarChallenges,
        challengeGroupIDs,
        setChallengeGroupIDs,
        isFetching,
        fetchError,
        fieldErrors,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        challengeGroupOptions,
        selectedChallengeID,
        setSetelectedChallengeID,
    } = useFetchCalendarChallenges();
    return (
        <>
            <Breadcrumb items={challengeCalendarBreadcrumb} title="Challenge Calendar" />
            <Title>Challenge Calendar</Title>
            <CalendarFilters
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                challengeGroupIDs={challengeGroupIDs}
                setChallengeGroupIDs={setChallengeGroupIDs}
                challengeGroupOptions={challengeGroupOptions}
                fieldErrors={fieldErrors}
            />
            <DataCheck
                isFetching={isFetching}
                error={fetchError}
                dataExists={!isEmpty(calendarChallenges)}
            >
                <Calendar
                    challenges={calendarChallenges}
                    startDate={startDate}
                    endDate={endDate}
                    selectedChallengeID={selectedChallengeID}
                    setSelectedChallengeID={setSetelectedChallengeID}
                />
            </DataCheck>
        </>
    );
}

export default ChallengeCalendar;
